module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('instamapsBreadcrumbs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasBreadcrumbs),
      expression: "hasBreadcrumbs"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "darkblue-theme shadowed"
  }, [_c('bannerSlider', {
    class: {
      nobreadcrumbs: !_vm.hasBreadcrumbs
    },
    attrs: {
      "selectedLang": _vm.selectedLang
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "highlights"
  }, [_c('div', {
    staticClass: "cta"
  }, [_c('router-link', {
    staticClass: "yellow-theme",
    attrs: {
      "to": "gallery"
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.goToGallery')))]), _vm._v(" "), _c('a', {
    staticClass: "green-theme",
    attrs: {
      "href": _vm.mapa
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.createMap')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "darkblue-theme"
  }, [_c('itemsSlider', {
    attrs: {
      "homePreviewMaps": _vm.homePreviewMaps,
      "selectedLang": _vm.selectedLang
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "highlights"
  }, [_c('div', {
    staticClass: "cta"
  }, [_c('router-link', {
    attrs: {
      "to": "gallery"
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.seeMoreMaps')))])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "highlights background-light yellow-theme"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("near_me")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('highlightOne.title')))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('highlightOne.subtitle')))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("map")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('highlightOne.columnOne.title')))])]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('highlightOne.columnOne.content'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("timeline")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('highlightOne.columnTwo.title')))])]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('highlightOne.columnTwo.content'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("place")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('highlightOne.columnThree.title')))])]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('highlightOne.columnThree.content'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cta"
  }, [_c('router-link', {
    attrs: {
      "to": "gallery"
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.goToGallery')))])], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "highlights green-theme"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("create")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('highlightTwo.title')))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('highlightTwo.subtitle')))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "content row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("gesture")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('highlightTwo.columnOne.title')))])]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('highlightTwo.columnOne.content'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cloud_upload")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('highlightTwo.columnTwo.title')))])]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('highlightTwo.columnTwo.content'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("call_merge")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('highlightTwo.columnThree.title')))])]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('highlightTwo.columnThree.content'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cta"
  }, [_c('a', {
    attrs: {
      "href": _vm.mapa
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.mapsEditor')))])])])]), _vm._v(" "), _c('section', {
    staticClass: "highlights background-light blue-theme"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("remove_red_eye")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('highlightThree.title')))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('highlightThree.subtitle')))])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "content row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("phone_iphone")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('highlightThree.columnOne.title')))])]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('highlightThree.columnOne.content'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("print")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('highlightThree.columnTwo.title')))])]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('highlightThree.columnTwo.content'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cloud_download")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('highlightThree.columnThree.title')))])]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('highlightThree.columnThree.content'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cta"
  }, [_c('router-link', {
    attrs: {
      "to": "gallery"
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.goToGallery')))])], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "highlights darkblue-theme extra-bottom-padding"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("group")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('highlightFour.title')))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('highlightFour.subtitle')))])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "content row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("share")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('highlightFour.columnOne.title')))])]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('highlightFour.columnOne.content'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("mail_outline")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('highlightFour.columnTwo.title')))])]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('highlightFour.columnTwo.content'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("insert_link")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('highlightFour.columnThree.title')))])]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('highlightFour.columnThree.content'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cta"
  }, [_c('router-link', {
    attrs: {
      "to": "gallery"
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.goToGallery')))])], 1)])]), _vm._v(" "), _c('instamapsInfoModal', {
    attrs: {
      "delay": 1000
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cropped-image"
  }, [_c('img', {
    staticClass: "featured-image lazyload",
    attrs: {
      "data-src": "/static/img/instamaps-banner-1.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cropped-image"
  }, [_c('img', {
    staticClass: "featured-image lazyload",
    attrs: {
      "data-src": "/static/img/instamaps-banner-2.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cropped-image"
  }, [_c('img', {
    staticClass: "featured-image lazyload",
    attrs: {
      "data-src": "/static/img/instamaps-banner-3.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cropped-image"
  }, [_c('img', {
    staticClass: "featured-image lazyload",
    attrs: {
      "data-src": "/static/img/instamaps-banner-4.jpg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-108a6882"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/home/home.vue
// module id = 288
// module chunks = 0